type TableRowSkeletonProps = {
  columnCount: number;
};

const TableRowSkeleton = ({ columnCount }: TableRowSkeletonProps) => {
  return (
    <tr className="animate-pulse">
      {Array.from({ length: columnCount }).map((_, index) => (
        <td key={index} className="px-4 py-3">
          <div className="h-4 rounded bg-myteengig-background" />
        </td>
      ))}
    </tr>
  );
};

export default TableRowSkeleton;
